import React, { useState, useEffect, useContext } from "react";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import axios from "axios";
import { AuthContext } from "../../../Context/AuthContext";
import Preloader from "../../../shared/PreLoaders";
import { logActivity } from "../../../utils/LogActivity";
import { Authorization } from "../../../Context/Authorization";
const ManageMemberDesignation = () => {
  const [vfcName, setVfcName] = useState([]);
  const [selectedVfc, setSelectedVfc] = useState("");
  const [designations, setDesignations] = useState([]);
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);
    const fetchVfc = async () => {
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs`, config);
        const data = response.data.vfcs;
        setVfcName(data);
      } catch (error) {
        console.log("Error fetching VFCs", error);
      }
      setLoading(false);
    };
    fetchVfc();
  }, [Api]);

  const handleVfcChange = async (event) => {
    const vfcId = event.target.value;
    setLoading(true);
    setSelectedVfc(vfcId);
    try {
      const config = Authorization();
      // Fetch designations for the selected VFC
      const response = await fetch(
        `${Api}/api/member/designation/all-designations`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...config.headers,
          },
          body: JSON.stringify({ vfcId }), // Send vfcId in request body
        }
      );
      const data = await response.json();
      await logActivity(
        userId,
        "Viewed Managemember Designation",
        "Managemember Designation Page",
        Api
      );
      setDesignations(data);
    } catch (error) {
      console.log("Error fetching designations", error);
    }
    setLoading(false);
  };

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title"> Members Designation</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Members Designation
            </li>
          </ol>
        </nav>
      </div>
      <Container className="my-5">
        <>
          <Row>
            <div className="col-md-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <Form.Group controlId="vfcName" className="mb-3">
                    <Form.Label>VFC Name</Form.Label>
                    <div className="input-container">
                      <Form.Control
                        as="select"
                        value={selectedVfc}
                        onChange={handleVfcChange}
                      >
                        <option value="">Select VFC</option>
                        {vfcName.map((vfc) => (
                          <option key={vfc._id} value={vfc._id}>
                            {vfc.vfcName}
                          </option>
                        ))}
                      </Form.Control>
                    </div>
                  </Form.Group>
                </div>
              </div>
            </div>
          </Row>
          <Row>
            <Col>
              {designations.length > 0 ? (
                <div className="card">
                  <div className="card-body">
                    <div className="row icons-list">
                      <div className="table-responsive">
                        <table striped bordered hover className="table">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              <th>Designation</th>
                              <th>Date</th>
                              <th>Note</th>
                            </tr>
                          </thead>
                          <tbody>
                            {designations.map((designation, index) => (
                              <tr key={designation._id}>
                                <td>{index + 1}</td>
                                <td>{designation.memberId.name}</td>
                                <td>{designation.designation}</td>
                                <td>
                                  {new Date(
                                    designation.date
                                  ).toLocaleDateString()}
                                </td>
                                <td>{designation.note}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <p>No designations found for the selected VFC</p>
              )}
            </Col>
          </Row>
        </>
      </Container>
    </div>
  );
};

export default ManageMemberDesignation;
